import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import LandingPage from './LandingPage';
import PesquisaPage from './PesquisaPage';
import PresentePage from './PresentePage';
import PrivacidadePage from './PrivacidadePage';
import { track } from './track';
import './index.css';

// Sinaliza ao GTM que esta página NÃO depende do VisitorAPI.
// Trigger "gtm.dom|sem-visitor-api" usa esse evento pra disparar
// as tags de PageView (FB / GA4 / TKT) sem o gate do jsc-st.
track('sem-visitor-api');

const path = window.location.pathname.replace(/\/$/, '').toLowerCase();

let Page: React.FC;
if (path === '/pesquisa') Page = PesquisaPage;
else if (path === '/presente') Page = PresentePage;
else if (path === '/privacidade') Page = PrivacidadePage;
else Page = LandingPage;

// Proteção leve contra download casual de imagens
document.addEventListener('contextmenu', (e) => {
  const target = e.target as HTMLElement;
  if (target && target.tagName === 'IMG') e.preventDefault();
});
document.addEventListener('dragstart', (e) => {
  const target = e.target as HTMLElement;
  if (target && target.tagName === 'IMG') e.preventDefault();
});

const root = document.getElementById('root')!;
const app = (
  <React.StrictMode>
    <Page />
  </React.StrictMode>
);

// Se o HTML inicial JÁ tem conteúdo (vindo do prerender.mjs), hidratamos por cima
// — LCP é o snapshot estático, depois React assume sem repintar.
// Se não tiver (dev mode), createRoot normal.
if (root.firstChild) {
  hydrateRoot(root, app);
} else {
  createRoot(root).render(app);
}

// Pausa animações dos .btn-cta quando estão fora da viewport — economiza GPU/CPU
// e ajuda no INP/Total Blocking Time. Re-escaneia o DOM via MutationObserver
// pra pegar botões renderizados em modals/portals.
const setupCTAVisibility = () => {
  const io = new IntersectionObserver((entries) => {
    for (const e of entries) e.target.classList.toggle('paused', !e.isIntersecting);
  });
  const scan = (rootEl: ParentNode) => {
    rootEl.querySelectorAll<HTMLElement>('.btn-cta:not([data-cta-obs])').forEach((el) => {
      el.setAttribute('data-cta-obs', '');
      io.observe(el);
    });
  };
  scan(document);
  new MutationObserver((muts) => {
    for (const m of muts) for (const n of m.addedNodes) if (n instanceof Element) scan(n);
  }).observe(document.body, { childList: true, subtree: true });
};
// Roda só DEPOIS do load + idle pra não competir com o LCP/TTI.
const deferredSetup = () => {
  type IdleAPI = (cb: () => void, opts?: { timeout: number }) => void;
  const w = window as unknown as { requestIdleCallback?: IdleAPI };
  if (w.requestIdleCallback) w.requestIdleCallback(setupCTAVisibility, { timeout: 2000 });
  else setTimeout(setupCTAVisibility, 1500);
};
if (document.readyState === 'complete') deferredSetup();
else window.addEventListener('load', deferredSetup, { once: true });
